<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Orders</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Orders
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Orders</h4>
                    <div class="col-lg-3 col-md-4 col-sm-6 d-flex">
                        <!-- Hidden exporter -->
                        <download-excel
                            ref="exporter-csv"
                            :data="exportOrders"
                            :export-fields="exportFields"
                            type="csv"
                            style="display: none"
                        />
                        <download-excel
                            ref="exporter-xls"
                            :data="exportOrders"
                            :export-fields="exportFields"
                            type="xls"
                            style="display: none"
                        />
                        <!-- Export button -->
                        <a href="#" @click="exportData('csv')" class="export-link">
                            <i class="fas fa-file-csv"></i> Export to CSV
                        </a> | &nbsp;
                        <a href="#" @click="exportData('xls')" class="export-link text-warning">
                            <i class="fa fa-file-excel-o"></i> Export to Excel</a>
                    </div>
                </div>

                <div class="card-body">
                    <form>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Name/ Email/ Phone Number</label>
                                    <input name="search" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.search">
                                    <template v-if="errors.search">
                                        <small class="text-danger" v-for="error in errors.search">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Order ID</label>
                                    <input name="order_no" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.order_no">
                                    <template v-if="errors.order_no">
                                        <small class="text-danger" v-for="error in errors.order_no">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Store</label>
                                    <select name="store" class="form-control form-control-sm"
                                            v-model="filters.store">
                                        <option :value="null" :selected="filters.store==null">All</option>
                                        <option v-for="store in stores" :key="store.id"
                                                :value="store.id">
                                            {{ store.name }}
                                        </option>
                                    </select>
                                    <template v-if="errors.store">
                                        <small class="text-danger" v-for="error in errors.store">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Status</label>
                                    <select name="category" id="category" class="form-control form-control-sm"
                                            v-model="filters.status">
                                        <option :value="null" :selected="filters.status==null">All</option>
                                        <option v-for="status in statuses" :key="status"
                                                :value="status">
                                            {{ status }}
                                        </option>
                                    </select>
                                    <template v-if="errors.status">
                                        <small class="text-danger" v-for="error in errors.status">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Payment Channel</label>
                                    <select name="category" id="category" class="form-control form-control-sm"
                                            v-model="filters.payment_channel">
                                        <option :value="null" :selected="filters.payment_channel==null">All</option>
                                        <option v-for="payment_channel in payment_channels" :key="payment_channel"
                                                :value="payment_channel">
                                            {{ payment_channel }}
                                        </option>
                                    </select>
                                    <template v-if="errors.payment_channel">
                                        <small class="text-danger" v-for="error in errors.payment_channel">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Order Type</label>
                                    <select name="type" id="type" class="form-control form-control-sm"
                                            v-model="filters.type">
                                        <option :value="null">All</option>
                                        <option value="PICKUP">Pickup</option>
                                        <option value="DELIVERY">Delivery</option>
                                    </select>
                                    <template v-if="errors.type">
                                        <small class="text-danger" v-for="error in errors.type">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="store-free-delivery">By delivery type</label>
                                    <select id="store-free-delivery" name="store_free_delivery"
                                            class="form-control form-control-sm"
                                            v-model="filters.store_free_delivery">
                                        <option :value="null">All</option>
                                        <option value="1">Kilimanjaro Free Delivery</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Start Date</label>
                                    <date-time-field name="category" id="category" class="form-control form-control-sm" v-model="filters.start_date" bound="start"></date-time-field>
                                    <template v-if="errors.start_date">
                                        <small class="text-danger" v-for="error in errors.start_date">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-12 col-xs-12">
                                <div class="form-group">
                                    <label for="category">By End Date</label>
                                    <date-time-field name="category" id="category" class="form-control form-control-sm" v-model="filters.end_date" bound="end"></date-time-field>
                                    <template v-if="errors.end_date">
                                        <small class="text-danger" v-for="error in errors.end_date">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-12 mb-2">
                                <label>&nbsp;</label>
                                <br>
                                <button type="submit" @click.prevent="paginatedData"
                                        class="btn btn-primary glow mb-1 mb-sm-0">Apply Filter
                                </button>
                                <button type="reset" @click.prevent="resetFilters"
                                        class="btn btn-warning glow mb-1 mb-sm-0">
                                    Reset Filter
                                </button>
                            </div>
                        </div>
                    </form>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allOrders"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'order_no'">
                                <a :href="route('admin.orders.show', props.row.id)">
                                    {{ props.row.order_no }}
                                    <span v-if="props.row.store_free_delivery" class="badge badge-danger">Kilimanjaro Free Delivery</span>
                                </a>
                            </span>
                            <span v-else-if="props.column.field === 'is_new'">
                                <template v-if="props.row.is_new">
                                    <span class="badge badge-glow badge-success">Yes</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">No</span>
                                </template>
                            </span>
                            <span v-else-if="props.column.field === 'user.phone'">
                                <a v-if="props.row.user?.phone" :href="'tel:'+ props.row.user.phone">{{ props.row.user.phone }}</a>
                            </span>
                            <span v-else-if="props.column.field === 'status'">
                                <small><i :class="props.row.type !== 'PICKUP' ? 'fa fa-motorcycle' : 'fa fa-user'"></i>{{ props.row.status }}</small><br>
                                <small><i class="fa fa-money"></i>{{
                                        props?.row?.transaction?.status ?? "YET TO PAY"
                                    }}</small>
                            </span>
                            <span v-else-if="props.column.field === 'payment_method_label'">
                                {{ props.row.payment_method_label || props.row.payment_channel }}
                            </span>
                            <span v-else-if="props.column.field === 'balance_applied'">
                                <small>₦{{
                                        props.row.balance_applied
                                    }}</small>
                                <small :class="props.row.balance_applied_status ? 'text-success': 'text-danger'" v-if="props.row.balance_applied > 0">({{
                                        props.row.balance_applied_status ? 'Deducted' : 'Yet to Be Deducted'
                                    }})</small>
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a :href="route('admin.orders.show', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-eye"></i> View
                                </a>
                                <a :href="route('admin.orders.edit', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-edit"></i> Edit Order
                                </a>
                                <a
                                    v-if="$page.props.can.edit_order && !props.row.refunded && props.row.transaction?.status === 'PAID'"
                                    href="#"
                                    class="dropdown-item"
                                    @click.prevent="refundCustomerModal(props.row.id, props.row.grand_total - props.row.discount)"
                                >
                                    <i class="feather icon-dollar-sign"></i> Refund User
                                </a>
                                <a href="#" class="dropdown-item text-danger" @click.prevent="showAlert(props.row.id)">
                                    <i class="feather icon-trash-2"></i> Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>

        <div class="modal fade refund-customer-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
             aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="requestRefundCode">
                        <div class="modal-header"><h4 id="myModalLabel1" class="modal-title">Refund User</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group"><label>Amount</label>
                                <input type="text" required="required" v-model="refundCustomer.amount"
                                       class="form-control">
                            </div>
                            <p v-if="refundError" class="text-danger">{{ refundError }}</p>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" :disabled="saving">
                                Send code <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal fade refund-otp-modal" tabindex="-1" role="dialog" aria-labelledby="refundOtpLabel"
             aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="refundUser">
                        <div class="modal-header"><h4 id="refundOtpLabel" class="modal-title">Confirm refund</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <p>A 6-digit code was sent to the super admins. It expires in 30 minutes. Enter the code they give you to add this refund to the customer wallet.</p>
                            <div class="form-group"><label>Confirmation code</label>
                                <input type="text" required="required" maxlength="6" inputmode="numeric"
                                       autocomplete="one-time-code" v-model="refundCustomer.code"
                                       class="form-control">
                            </div>
                            <p v-if="refundError" class="text-danger">{{ refundError }}</p>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary" :disabled="saving">
                                Confirm refund <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import TableExportMixin from "../../Shared/Mixins/TableExportMixin";
import {formatDateTime} from "../../utils";

export default {
    metaInfo: {title: 'Orders'},
    props: [
        'orders',
        'stores',
        'payment_channels',
        'statuses',
        'payment_statuses',
        'userId',
    ],
    layout: Layout,
    name: 'OrderIndex',
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        TableExportMixin,
    ],
    data() {
        return {
            errors: {},
            saving: false,
            filters: {
                status: null,
                store: null,
                payment_channel: null,
                start_date: null,
                end_date: null,
                order_no: null,
                search: null,
                type: null,
                store_free_delivery: null,
            },
            isLoadingFilter: false,
            allOrders: [],
            exportOrders: [],
            refundError: '',
            refundCustomer: {
                order_id: null,
                amount: null,
                code: '',
            },
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 100,
                columnFilters: {},
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 100,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },
            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Order Date', field: 'date_added',
                    thClass: 'text-center', tdClass: 'text-center',
                    formatFn: formatDateTime,
                },
                {label: 'Order Number', field: 'order_no', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Full Name', field: 'user.first_name',
                    thClass: 'text-center', tdClass: 'text-center',
                    formatFn: this.formatFullName
                },
                {label: 'Store', field: 'store.name', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Order Total',
                    field: 'amount_paid',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatFn
                },
                {label: 'Order Type', field: 'type', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Status', field: 'status',
                    thClass: 'text-center', tdClass: 'text-center',
                },
                {
                    label: 'Payment method', field: 'payment_method_label',
                    thClass: 'text-center', tdClass: 'text-center',
                },
                {
                    label: 'Created Time',
                    field: 'created_at',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: formatDateTime,
                },
                {
                    label: 'Scheduled Time',
                    field: 'scheduled_time',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatTime,
                },
                {label: 'Phone', field: 'user.phone', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Balance Applied',
                    field: 'balance_applied',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatFn
                },
                {
                    label: 'Amount Refunded',
                    field: 'amount_refunded',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatFn
                },
                {label: 'Action', field: 'action', sortable: false, width: '70px', thClass: 'text-center', tdClass: 'text-center'},
            ],
            tableDataLoading: false,
        }
    },
    computed: {
        exportFields() {
            const fields = {};
            this.columns.forEach(x => {
                if (x.label !== 'action') fields[x.label] = x.field;
            });

            return fields;
        },
    },
    mounted() {
        this.allOrders = this.orders.data;
        this.totalRecords = this.orders.total;
        this.paginationOptions.perPage = this.orders.per_page;
        this.serverParams.perPage = this.orders.per_page;
        this.serverParams.page = this.orders.current_page;
    },

    methods: {
        async refundCustomerModal(id, amount) {
            this.refundError = '';
            this.refundCustomer.code = '';
            this.refundCustomer.amount = amount;
            this.refundCustomer.order_id = id;
            $('.refund-customer-modal').modal('show');
        },
        csrfHeaders() {
            return {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                'Accept': 'application/json',
            };
        },
        errorText(error) {
            const data = error.response && error.response.data;

            if (data && data.errors) {
                const first = Object.values(data.errors)[0];

                return Array.isArray(first) ? first[0] : String(first);
            }

            if (data && data.message) {
                return data.message;
            }

            return 'Could not complete that request.';
        },
        async requestRefundCode() {
            this.saving = true;
            this.refundError = '';

            try {
                await axios.post(route('admin.orders.refund-user.otp'), {
                    order_id: this.refundCustomer.order_id,
                    amount: this.refundCustomer.amount,
                }, {headers: this.csrfHeaders()});
                this.refundCustomer.code = '';
                $('.refund-customer-modal').modal('hide');
                $('.refund-otp-modal').modal('show');
            } catch (error) {
                this.refundError = this.errorText(error);
            } finally {
                this.saving = false;
            }
        },
        getCurrentDate() {
            const local = new Date();
            local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
            return local.toJSON().slice(0, 10);
        },
        formatFn(value) {
            return '₦' + (value ?? 0);
        },
        formatFullName(value, row) {
            if (! row.user) {
                return '—';
            }

            return row.user.first_name + ' ' + row.user.last_name;
        },
        formatTime(value, row) {
            return value===null ? "Now" : value;
        },
        async paginatedData() {
            try {
                let routeName = this.userId ? route('admin.customers.orders', this.userId) : route('admin.orders.index');
                this.errors = {};
                let response = await axios.get(routeName, {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                        ...this.filters
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allOrders = response.data.data
            } catch (error) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    console.log(error);
                }
            }
        },
        async deleteOrder(id) {
            this.$inertia.delete(route('admin.orders.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.paginatedData();
                }
            })
        },
        async refundUser() {
            this.saving = true;
            this.refundError = '';

            try {
                const response = await axios.post(route('admin.orders.refund-user'), {
                    order_id: this.refundCustomer.order_id,
                    amount: this.refundCustomer.amount,
                    code: this.refundCustomer.code,
                }, {headers: this.csrfHeaders()});
                $('.refund-otp-modal').modal('hide');
                this.$swal.fire({
                    title: 'Refund completed',
                    text: response.data.message,
                    type: 'success',
                    confirmButtonClass: 'btn btn-primary',
                    buttonsStyling: false,
                });
                this.paginatedData();
            } catch (error) {
                this.refundError = this.errorText(error);
            } finally {
                this.saving = false;
            }
        },
        async resetFilters() {
            for (let filter in this.filters) {
                this.filters[filter] = null;
            }
            await this.paginatedData();
        },
        async showAlert(orderId) {
            const details = {
                title: "Are you sure you want to delete this order?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteOrder(orderId) : "";
        },
        async exportData(fileType = 'csv') {
            try {
                let routeName = this.userId ? route('admin.customers.orders', this.userId) : route('admin.orders.index');
                this.errors = {};
                let response = await axios.get(routeName, {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                        no_pagination: true,
                        ...this.filters,
                        file_type: fileType
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                if (response.data.message) {
                    this.showExportFlash('success', response.data.message);
                } else {
                    let name = `exporter-${fileType}`;
                    this.exportOrders = response.data;

                    this.$nextTick(() => {
                        this.$refs[name].generate();
                    });
                }
            } catch (error) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    console.log(error);
                }
            }
        },
    }
}
</script>
